var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn-container rounded-xl pa-1 cursor-pointer",on:{"click":function($event){return _vm.reloadWithoutCache()}}},[_c('div',{staticClass:"btn-caption"},[_vm._v("Recargar sin caché")]),_c('v-icon',{staticClass:"btn-icon",attrs:{"size":"35px"}},[_vm._v(" mdi-refresh-circle ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }